import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IStandardTranscriptNormalized } from '../../shared/models/standard-transcript-normalized.model';
import { IAceTranscriptAPIResponse } from '../../shared/interfaces/ace-transcript.interface';
import { HttpErrorResponse } from '@angular/common/http';

export const STANDARD_TRANSCRIPTION_API_ACTIONS = createActionGroup({
  source: 'Standard Transcription API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: IStandardTranscriptNormalized }>(),
  },
});

export const ACE_TRANSCRIPTION_API_ACTIONS = createActionGroup({
  source: 'Ace Transcription API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: IAceTranscriptAPIResponse }>(),
  },
});

export const AUDIO_API_ACTIONS = createActionGroup({
  source: 'Audio API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: string }>(),
  },
});
